// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"MPArticleSkeleton_loadingOverlay__VTTTf","loadingContent":"MPArticleSkeleton_loadingContent__HzURU","loadingText":"MPArticleSkeleton_loadingText__0X6Gy"};